"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    createVirtualElementFromClick: function() {
        return _createVirtualElementFromClick.createVirtualElementFromClick;
    },
    createArrowHeightStyles: function() {
        return _createArrowStyles.createArrowHeightStyles;
    },
    createArrowStyles: function() {
        return _createArrowStyles.createArrowStyles;
    },
    createSlideStyles: function() {
        return _createSlideStyles.createSlideStyles;
    },
    usePositioning: function() {
        return _usePositioning.usePositioning;
    },
    usePositioningMouseTarget: function() {
        return _usePositioningMouseTarget.usePositioningMouseTarget;
    },
    resolvePositioningShorthand: function() {
        return _index.resolvePositioningShorthand;
    },
    mergeArrowOffset: function() {
        return _index.mergeArrowOffset;
    }
});
const _createVirtualElementFromClick = require("./createVirtualElementFromClick");
const _createArrowStyles = require("./createArrowStyles");
const _createSlideStyles = require("./createSlideStyles");
const _usePositioning = require("./usePositioning");
const _usePositioningMouseTarget = require("./usePositioningMouseTarget");
const _index = require("./utils/index");
